export default "__VITE_ASSET__aadd69c6__"